const four04 = () => {
    const view = `<strong class="text-center mt-4">Sorry, we did not found information under your selection. Please select another term.</strong>`;

    return view;
};

export default four04;
  